<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<div class="treeNoChoose">
						<div class="selectSpot2">
							<el-tree :load="loadChild" @node-click="nodeClick" ref="tree" :props="treeProps" :accordion='false' lazy
							 node-key="id" :default-expanded-keys="['0']" highlight-current>
								<div class="custom-tree-node" slot-scope="{node,data}">
									<div class="title" style="width:250px;position:relative;display: flex">
										<p style="width: 200px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
											{{data.name}}
										</p>
									</div>
								</div>
							</el-tree>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title">{{organizationName}}</p>

						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 150px;">
											<p>{{$t('label_563')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-input v-model="queryCondition.name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose">
										<div class="selectText" style="width: 180px;">
											<p>{{$t('label_22')}}</p>
										</div>
										<div class="select" style="width:350px">
											<el-input v-model="queryCondition.role" clearable></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>

						<div class="spotMes2Box" style="height: calc(100% - 110px);">
							<div class="spotMesBox" style="height:100%;">

								<div style="height: 100%">
									<div class="buttonBox" style='justify-content: space-between;'>
										<div>
											<div class="chooseButton searchButton" @click="add" v-if="MenuRoleList.indexOf('55')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}</div>
											<div class="chooseButton searchButton" @click="edit" v-if="MenuRoleList.indexOf('56')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}</div>
											<div class="chooseButton deleteButton" @click="remove" v-if="MenuRoleList.indexOf('57')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}
											</div>
											<div class="chooseButton memberButton" @click="resetPassword" v-if="MenuRoleList.indexOf('58')>=0"><i class="el-icon-refresh"></i>{{$t('btn_57')}}
											</div>
										</div>
										<el-checkbox v-model='expand' @change='clickExpand' style='font-size:14px;font-weight:600;color:#3fb393;'>{{$t('btn_58')}}</el-checkbox>
									</div>
									<div class="tableMin" style="height: calc(100% - 100px);">
										<el-table :empty-text="$t('label_357')" :data="tableData" @current-change="tableCurrentChange" ref="singleTable" highlight-current-row
										 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
											<el-table-column :label="$t('label_369') + '.'" header-align="center" align="center" type="index" width="50">
											</el-table-column>
											<el-table-column :label="$t('label_72')" width='140'>
												<template slot-scope="scope">
													<div @dblclick='nameClick(scope.row)'>
														{{scope.row.name}}<br>
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="workerNumber" :label="$t('label_559')" width='120'>
											</el-table-column>
											<el-table-column :label="$t('label_22')">
												<template slot-scope="scope">
													<div v-if='scope.row.roleNames!=null'>
														<div v-for='(item,index) in scope.row.roleNames.split(",")' :key="index" class='contactRow'>
															<span>{{formatRoleName(item)}}</span>
														</div>
													</div>
												</template>
											</el-table-column>
											<el-table-column :label="$t('label_412')" align="center" width='140'>
												<template slot-scope="scope">
													<el-switch v-model="scope.row.state" :active-value='1' :inactive-value='0' :active-text="$t('label_10')" :inactive-text="$t('label_6')"
													 active-color="#3fb393" inactive-color="#ff3300" @change="stateChange(scope.row)" :disabled="!(MenuRoleList.indexOf('55')>=0||MenuRoleList.indexOf('56')>=0||MenuRoleList.indexOf('57')>=0)">
													</el-switch>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div style="position: absolute;bottom: 10px;left: 30%">
										<Page :total="pageCount" :display="pageSize" @parentMethod="searchPage" ref="pageModel" :pagegroup="3"
										 :currentspage="1" class="item"></Page>
									</div>

									<el-dialog :visible.sync="testVisible" title="" append-to-body center>
										<el-input v-model='testInput'></el-input>
										<div @click="test" class="chooseButton sendButton">{{$t('btn_20')}}</div>
									</el-dialog>

									<el-dialog v-loading="saveLoading" :visible.sync="dialogVisible" :title="dialogTitle" :before-close="dialogClose" append-to-body
									 :close-on-click-modal='false' width="800px" top="5%" custom-class="dialogBox">
										<div class="dialogBoxMes" style="padding:0 20px;">
											<el-row class="dialogMes">
												<el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*
												</el-col>
												<el-col :span="3">{{$t('label_563')}}</el-col>
												<el-col :span="8">
													<el-input v-model="formModel.name" clearable></el-input>
												</el-col>
											</el-row>
											<el-row class="dialogMes">
												<el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*
												</el-col>
												<el-col :span="3">{{$t('label_82')}}</el-col>
												<el-col :span="8">
													<el-input v-model="formModel.username" clearable></el-input>
												</el-col>
												<el-col :span="1"></el-col>
												<el-col :span="3">{{$t('label_559')}}</el-col>
												<el-col :span="8">
													<el-input v-model="formModel.workerNumber" clearable>
													</el-input>
												</el-col>
											</el-row>
											<el-row class="dialogMes">
												<el-col :span="1"></el-col>
												<el-col :span="3">{{$t('label_304')}}</el-col>
												<el-col :span="20">
													<div class="treeNoChoose">
														<div class="selectSpot2" style='height: 100%;'>
															<el-tree :load="loadTree" @check-change="treeCheck" ref="tree" show-checkbox check-strictly lazy :props="treeProps"
															 :accordion='true' node-key="id" :default-expanded-keys="expandedKeys">
																<div class="custom-tree-node" slot-scope="{node,data}">
																	<div class="title" style="width:250px;position:relative;display: flex">
																		<p style="width: 150px;display: block;overflow: hidden;line-height: 30px;text-overflow: ellipsis;-o-text-overflow: ellipsis; white-space: nowrap;">
																			{{data.name}}
																		</p>
																	</div>
																</div>
															</el-tree>
														</div>
													</div>
												</el-col>
											</el-row>
											<el-row class="dialogMes">
												<el-col :span="1" style='color:#ff0000;text-align: right;padding-right: 5px;'>*
												</el-col>
												<el-col :span="3">{{$t('label_22')}}</el-col>
												<el-col :span="20">
													<el-checkbox-group v-model="formModel.roleIds" v-if='roles.length!=0'>
														<span v-for='(item,index) in roles' :key="index">
															<el-checkbox :label="item.roleId">
																<span style='margin-right: 15px;'>{{item.roleName}}</span>
															</el-checkbox>
														</span>
													</el-checkbox-group>
												</el-col>
											</el-row>
											<el-row class="dialogMes">
												<el-col :span="1"></el-col>
												<el-col :span="3">{{$t('label_85')}}</el-col>
												<el-col :span="8">
													<el-input v-model="formModel.mobile" clearable>
													</el-input>
												</el-col>
												<el-col :span="1"></el-col>
												<el-col :span="3">{{$t('label_726')}}</el-col>
												<el-col :span="8">
													<el-input v-model="formModel.email" clearable>
													</el-input>
												</el-col>
											</el-row>
										</div>
										<span slot="footer" class="dialog-footer">
											<div @click="save" class="chooseButton sendButton">{{$t('btn_13')}}</div>
										</span>
									</el-dialog>

									<el-dialog :visible.sync="viewDialogVisible" :title="$t('label_89')" append-to-body custom-class="dialogBox" top="5%">
										<div style='width:90%;margin-left:5%;'>
											<span style='font-size: 20px;'><span style='margin-right:10px;font-weight:600;'>{{viewModel.name}}</span>{{viewModel.workerNumber}}</span>
											<div class='viewDialogTable'>
												<label class='viewDialogLabel'>{{$t('label_82')}}</label>
												<div>{{viewModel.username}}</div>
												<label class='viewDialogLabel'>{{$t('label_569')}}</label>
												<div>
													<img src="../../assets/img/phone.png">{{viewModel.mobile}}
													<img src="../../assets/img/mail.png">{{viewModel.email}}
												</div>
												<label class='viewDialogLabel'>{{$t('label_20')}}</label>
												<div style='height:300px;overflow-y: scroll;'>
													<el-checkbox-group v-model="viewModel.menuIds">
														<span v-for='(menu,index) in allMenus' :key="index">
															<p v-if='menu.type!=99' style='height:1px;'></p>
															<span :class='"menuName"+menu.type+" folder"+index'>
																<el-checkbox :label="menu.id" disabled>
																	<span :class="'menuText'+menu.type">{{$t(menu.name)}}</span>
																</el-checkbox>
															</span>
														</span>
													</el-checkbox-group>
												</div>
											</div>
										</div>
									</el-dialog>

									<el-dialog :visible.sync="resetPasswordVisible" :title="$t('btn_57')" append-to-body width="30%" top="10%"
									 :close-on-click-modal='false' center custom-class="dialogBox">
										<p style="text-align: center;font-size: 16px">{{$t('label_92')}}</p>
										<div class="btnBox2" style="width: 100%;justify-content: center;">
											<div @click="resetPasswordVisible = false" class="editButton">{{$t('btn_1')}}</div>
											<div @click="reset" class="delButton"><i class="el-icon-refresh"></i>{{$t('label_95')}}
											</div>
										</div>
									</el-dialog>

								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import utils from '@/utils/utils'
	import organizationTabJs from "@/assets/js/system/organizationTab.js";
	import menuTabJs from "@/assets/js/system/menuTab.js";
	import userJs from "@/assets/js/system/user.js";
	import Page from "@/components/common/page";

	export default {
		name: 'userPage',
		components: {
			Page
		},
		data() {
			return {
        saveLoading: false,
				input: '',
				queryCondition: {
					name: '',
					role: ''
				},
				pageSize: 10,
				pageCount: 0,
				pageNum: 1,
				expand: true,
				treeProps: {
					label: 'name',
				},
				expandedKeys: [],
				nodeId: '',
				hierarchy: '',
				level: 0,
				organizationName: '',
				//table
				tableData: [],
				MenuRoleList: [],
				currentRow: {},
				//edit dialog
				dialogVisible: false,
				dialogTitle: this.$t('label_99'),
				rolesArray: [],
				roles: [],
				formModel: {
					id: '',
					name: '',
					username: '',
					workerNumber: '',
					organizationIds: [],
					roleIds: [],
					mobile: '',
					email: '',
				},
				//viewDialog
				viewDialogVisible: false,
				viewModel: {
					name: '',
					username: '',
					workerNumber: '',
					mobile: '',
					email: '',
					menuIds: [],
				},
				allMenus: [],
				resetPasswordVisible: false,
				testVisible: false,
				testInput: '',
				begin: 0,
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			//tree
			loadChild(node, resolve) {
				if (this.begin == 0) {
					let child = this.getChildren(-1);
					child.then((res) => {
						this.organizationClick(res[0]);
						resolve(res);
					});
					this.begin++;
				} else {
					if (node.level === 0) {
						let child = this.getChildren(0);
						child.then((res) => {
							this.organizationClick(res[0]);
							resolve(res);
						});
					} else {
						let child = this.getChildren(node.data.id);
						child.then((res) => {
							if (res == "") {
								return resolve([]);
							} else {
								resolve(res);
							}
						});
					}
				}

			},
			async getChildren(pid) {
				let childArr = [];
				if (pid == -1) {
					childArr = [{
						name: this.$t('label_272'),
						id: '0',
					}]
				} else {
					await organizationTabJs.getChildren({
						pid: pid,
						state: 1
					}).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							childArr = data.data;

						}
					}).catch((response) => {
						console.log(response)
					})
				}
				return childArr;
			},
			organizationClick(data) {
				this.nodeId = data.id;
				this.expandedKeys = [this.nodeId];
				this.hierarchy = data.hierarchy;
				this.level = data.level;
				this.organizationName = data.name;
				this.searchPage({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				this.rolesArray = [];
				this.treeCheck(data, true, '');
			},
			nodeClick(data, checked, resolve) {
				this.pageNum = 1;
				this.organizationClick(data);
			},

			add() {
				this.dialogVisible = true;
				this.dialogTitle = this.$t('label_99');
				this.$nextTick(_ => {
					this.$refs.tree.setCurrentKey(this.nodeId);
					this.$refs.tree.setCheckedKeys([this.nodeId]);
				});
			},
			edit() {
				if (Object.keys(this.currentRow).length > 0) {
					this.formModel.id = this.currentRow.userId;
					this.formModel.name = this.currentRow.name;
					this.formModel.username = this.currentRow.username;
					this.formModel.workerNumber = this.currentRow.workerNumber;
					this.formModel.mobile = this.currentRow.mobile;
					this.formModel.email = this.currentRow.email;
					if (this.currentRow.organizationIds == null) {
						this.formModel.organizationIds = []
					} else {
						this.formModel.organizationIds = this.currentRow.organizationIds.split(',')
					}
					let roleNames = []
					if (this.currentRow.roleNames != null) {
						roleNames = this.currentRow.roleNames.split(',');
					}
					this.formModel.roleIds = [];
					this.rolesArray = [];
					this.roles = [];

					let org_roles = []
					if (this.currentRow.roleNames != null) {
						org_roles = this.currentRow.roleIds.split(',');
					}
					let curOrg = org_roles.length == 0 ? '' : org_roles[0].split('_')[0];
					let roleA = [];
					for (let i = 0; i < org_roles.length; i++) {
						let org_role = org_roles[i].split('_');
						this.formModel.roleIds.push(org_role[1]);
						this.roles.push({
							roleId: org_role[1],
							roleName: roleNames[i]
						});
						if (org_role[0] == curOrg) {
							roleA.push({
								roleId: org_role[1],
								roleName: roleNames[i]
							});
						} else {
							curOrg = org_role[0];
							this.rolesArray.push(roleA);
						}
					}
					this.dialogTitle = this.$t('label_103');
					this.dialogVisible = true;
					this.$nextTick(_ => {
						this.expandedKeys = this.formModel.organizationIds;
						this.$refs.tree.setCurrentKey(this.formModel.organizationIds[0]);
						this.$refs.tree.setCheckedKeys(this.formModel.organizationIds);
					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			//组织机构
			loadTree(node, resolve) {
				if (node.level === 0) {
					let child = this.getChildren(0);
					child.then((res) => {
						resolve(res);
					});
				} else {
					let child = this.getChildren(node.data.id);
					child.then((res) => {
						if (res == "") {
							return resolve([]);
						} else {
							resolve(res);
						}
					});
				}
			},
			treeCheck(data, checked, indeterminate) {
				if (checked) {
					this.formModel.organizationIds.push(data.id);
					menuTabJs.getByOrganization({
						organizationId: data.id
					}).then((response) => {
						if (response.data.code == 1) {
							let addedRoles = [];
							let exist = false;
							for (let i = 0; i < response.data.data.length; i++) {
								if (this.roles.length == 0) {
									addedRoles.push({
										roleId: response.data.data[i].roleId,
										roleName: response.data.data[i].roleName
									});
								} else {
									exist = false;
									for (let j = 0; j < this.roles.length; j++) {
										if (response.data.data[i].roleId == this.roles[j].roleId) {
											exist = true;
											continue;
										}
									}
									if (!exist) {
										addedRoles.push({
											roleId: response.data.data[i].roleId,
											roleName: response.data.data[i].roleName
										});
									}
								}
							}
							this.roles = this.roles.concat(addedRoles);
							this.rolesArray.push(addedRoles);
						}
					}).catch((response) => {
						console.log(response);
					})
				} else {
					let index = this.formModel.organizationIds.indexOf(data.id);
					this.formModel.organizationIds.splice(index, 1);
					this.rolesArray.splice(index, 1);
					this.roles = [];
					for (let i = 0; i < this.rolesArray.length; i++) {
						this.roles = this.roles.concat(this.rolesArray[i]);
					}
				}
			},
			dialogClose() {
				this.formModel = {
					id: '',
					name: '',
					username: '',
					workerNumber: '',
					organizationIds: [],
					roleIds: [],
					mobile: '',
					email: '',
				};
				this.$refs.tree.setCheckedKeys([]);
				this.dialogVisible = false;
			},
			save() {
			  this.saveLoading = true;
				if (this.formModel.name == '') {
					utils.messageAlert(this.$t('msg_38'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.formModel.username == '') {
					utils.messageAlert(this.$t('msg_39'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.formModel.roleIds.length == 0) {
					utils.messageAlert(this.$t('input_8'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				this.$set(this.formModel, 'status', 1)
				if (this.dialogTitle == this.$t('label_99')) {
					userJs.insert(this.formModel).then((response) => {
						if (response.data.code == "1") {
							this.dialogVisible = false;
							// utils.messageAlert(this.$t('msg_18'), this.$t('label_358'), this.$t('label_100'));
							this.$message.success(this.$t('msg_18'))
							this.formModel = {
								id: '',
								name: '',
								username: '',
								workerNumber: '',
								organizationIds: [],
								roleIds: [],
								mobile: '',
								email: '',
							};
							this.$refs.tree.setCheckedKeys([]);
							this.roles = [];
							this.rolesArray = [];
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						} else {
							utils.messageAlert(this.$t('msg_146'), this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					userJs.update(this.formModel.id, this.formModel).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogVisible = false;
							// utils.messageAlert(this.$t('msg_19'), this.$t('label_358'), this.$t('label_100'));
              this.$message.success(this.$t('msg_19'));
							this.formModel = {
								id: '',
								name: '',
								username: '',
								workerNumber: '',
								organizationIds: [],
								roleIds: [],
								mobile: '',
								email: '',
							};
							this.$refs.tree.setCheckedKeys([]);
							this.roles = [];
							this.rolesArray = [];
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						} else {
							utils.messageAlert(this.$t('msg_146'), this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			remove() {
				if (Object.keys(this.currentRow).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						userJs.remove({
							id: this.currentRow.userId
						}).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								// utils.messageAlert(this.$t('msg_14'), this.$t('label_358'), this.$t('label_100'));
                this.$message.success(this.$t('msg_14'));
								this.searchPage({
									pageNum: this.pageNum,
									pageSize: this.pageSize,
								});
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			resetPassword() {
				if (Object.keys(this.currentRow).length > 0) {
					this.resetPasswordVisible = true;
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			reset() {
				userJs.resetPassword(this.currentRow.userId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						utils.tipsAlert(this.$t('msg_52'));
						this.resetPasswordVisible = false;
					} else {
						utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			clickExpand() {
				this.searchPage({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
			},
			//table
			tableCurrentChange(row) {
				this.currentRow = row;
			},
			formatRoleName(roleName) {
				let index = roleName.indexOf('/');
				if (index == -1) {
					return roleName;
				} else {
					return roleName.substr(index + 1);
				}
			},
			nameClick(item) {
				this.viewModel.name = item.name;
				this.viewModel.username = item.username;
				this.viewModel.workerNumber = item.workerNumber;
				this.viewModel.mobile = item.mobile;
				this.viewModel.email = item.email;
				if (item.menuIds != null) {
					this.viewModel.menuIds = item.menuIds.split(',');
				}
				this.viewDialogVisible = true;
			},
			stateChange(item) {
				userJs.updateState({
					id: item.userId,
					state: item.state
				}).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.searchPage({
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						});
					}
				}).catch((response) => {
					console.log(response)
				})
			},

			searchPage(param) {
				utils.startLoading();
				this.pageNum = param.pageNum;
				this.pageSize = param.pageSize;
				let prefix = this.hierarchy == null ? '' : this.hierarchy.substring(0, this.level * 2);
				userJs.getByOrganization({
					id: this.expand ? '' : this.nodeId,
					hierarchy: this.expand ? prefix : '',
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					name: this.queryCondition.name,
					role: this.queryCondition.role,
				}).then((response) => {
					if (response.data.code == 1) {
						this.tableData = response.data.data.lists;
						this.pageCount = response.data.data.total;
						this.pageSize = response.data.data.pageSize == 0 ? response.data.data.size : response.data.data.pageSize;
						this.pageNum = response.data.data.pageNum;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
					utils.endLoading();
				}).catch((response) => {
					console.log(response);
					utils.endLoading();
				})
			},
			search() {
				this.searchPage({
					pageNum: 1,
					pageSize: this.pageSize
				});
			},
			test() {
				if (this.testInput == '123456789') {
					userJs.test({
						parentId: '0'
					}).then((response) => {
						utils.messageAlert(this.$t('msg_23'), this.$t('label_358'), this.$t('label_100'));
						this.testVisible = false;
						this.testInput = '';
					});
				}
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
		},
		mounted() {
			menuTabJs.get().then((response) => {
				if (response.data.code == 1) {
					this.allMenus = response.data.data;
				}
			}).catch((response) => {
				console.log(response);
			})
		},
  }
</script>
<style scoped>
	.contactRow {
		height: 20px;
		margin-top: 3px;
		line-height: 20px;
		vertical-align: middle;
	}

	.contactRow img {
		height: 90%;
		line-height: 18px;
		vertical-align: middle;
	}

	.contactRow span {
		margin-left: 5px;
		line-height: 20px;
		vertical-align: middle;
	}

	.el-col {
		line-height: 40px;
	}

	/* viewDialog */
	.viewDialogTable {
		margin-top: 10px;
		border: 1px solid #aaaaaa;
	}

	.viewDialogLabel {
		display: block;
		width: 100%;
		padding: 6px;
		border-bottom: 1px solid #aaaaaa;
		background-color: #ebebeb;
		font-weight: 600;
	}

	.viewDialogTable div {
		width: 100%;
		padding: 6px;
	}

	.viewDialogTable img {
		height: 18px;
		line-height: 18px;
		margin-left: 30px;
		margin-right: 6px;
		vertical-align: middle;
	}

	/* 权限 */
	.menuName1 {
		display: block;
		width: 100%;
		border-top: 1px solid #c9c9c9;
	}

	[class^=menuName] {
		padding: 6px;
		line-height: 40px;
	}

	.folder0 {
		border-top-width: 0px !important;
	}

	.menuText1 {
		font-weight: 600;
	}

	.menuName2,
	.menuName3 {
		display: inline-flex;
		width: 140px;
	}

	.menuName99 {
		margin-right: 20px;
	}

	.memberButton {
		background-image: linear-gradient(#0353c1, #0353c1);
		color: #ffffff;
		border: none;
	}

	.memberButton {
		background: #0353c1;
		color: #ffffff;
	}

	.treeNoChoose .selectSpot2 {
		height: 100%;
	}
</style>
<style>
	.viewDialogTable .el-checkbox__inner {
		background-color: #999999 !important;
		border-color: #999999 !important;
	}

	.viewDialogTable .el-checkbox__label {
		color: #999999 !important;
	}

	.viewDialogTable .el-checkbox__inner::after {
		border-color: #ffffff !important;
		border-width: 3px;
	}

	.buttonBox .searchButton {
		background: #3fb393;
		color: #ffffff;
	}
	.right-showbtn-qrcode-background {
		/* position: absolute; */
		width: 10px;
		height: 80px;
		background-color: #9c9c9c;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
		margin: auto;
	}
	.right-showbtn {
		width: 10px;
		height: 100%;
		display: flex;
		position: relative;
		z-index: 100000;
	}
</style>



// WEBPACK FOOTER //
// src/pages/basic/userPage.vue